import { cn } from '../libs/tailwindMerge'

interface UserStatusBadgeProps {
  status: boolean
}

export function UserStatusBadge({ status }: UserStatusBadgeProps) {
  return (
    <div className="flex items-center justify-center">
      <div className={cn(
        'rounded-full h-2 w-2 mr-2',
        status
          ? 'bg-emerald-500'
          : 'bg-red-500',
      )}
      />
      <span>
        {status
          ? 'Ativo'
          : 'Inativo'}
      </span>
    </div>
  )
}
